import {
  PostProPlanRequestAction,
  PostProPlanSuccessAction,
  PostProPlanFailureAction,
  PostProPlanSuccessPayload,
  PostProSubscriptionRequestAction,
  PostProSubscriptionSuccessAction,
  PostProSubscriptionFailureAction,
  ResetProStateAction,
  CalculatePriceRequestAction,
  CalculatePriceRequestPayload,
  CalculatePriceSuccessAction,
  CalculatePriceSuccessPayload,
  CalculatePriceFailureAction,
  ClearProPlanAction,
  CreateAASubscriptionRequestAction,
  CreateAASubscriptionSuccessAction,
  CreateAASubscriptionFailureAction,
  AASubscriptionRequestPayload,
  PostProPlanRequestActionPayload,
  CreateOnlyAASubscriptionRequestAction,
  PostCreateOnlyAASubscriptionSuccessAction,
  PostAaChangeRequestSuccessPayload,
  ExecuteAASubscriptionRequestAction,
  ExecuteAaSubsCallParams
} from './pro.types';

export const postProPlanRequest = (
  payload: PostProPlanRequestActionPayload
): PostProPlanRequestAction => ({
  type: 'POST_PRO_PLAN_REQUEST',
  payload
});

export const postProPlanSuccess = (
  payload: PostProPlanSuccessPayload
): PostProPlanSuccessAction => ({
  type: 'POST_PRO_PLAN_SUCCESS',
  payload
});

export const postProPlanFailure = (): PostProPlanFailureAction => ({
  type: 'POST_PRO_PLAN_FAILURE'
});

export const clearProPlan = (): ClearProPlanAction => ({
  type: 'CLEAR_PRO_PLAN'
});

export const postProSubscriptionRequest = (
  payload: PostProSubscriptionRequestAction['payload']
): PostProSubscriptionRequestAction => ({
  type: 'POST_PRO_SUBSCRIPTION_REQUEST',
  payload
});

export const postProSubscriptionSuccess = (): PostProSubscriptionSuccessAction => ({
  type: 'POST_PRO_SUBSCRIPTION_SUCCESS'
});

export const postProSubscriptionFailure = (): PostProSubscriptionFailureAction => ({
  type: 'POST_PRO_SUBSCRIPTION_FAILURE'
});

export const calculatePriceRequest = (
  payload: CalculatePriceRequestPayload
): CalculatePriceRequestAction => ({
  type: 'CALCULATE_PRICE_REQUEST',
  payload
});

export const calculatePriceSuccess = (
  payload: CalculatePriceSuccessPayload
): CalculatePriceSuccessAction => ({
  type: 'CALCULATE_PRICE_SUCCESS',
  payload
});

export const calculatePriceFailure = (error: string): CalculatePriceFailureAction => ({
  type: 'CALCULATE_PRICE_FAILURE',
  payload: error
});

export const resetProState = (): ResetProStateAction => ({
  type: 'RESET_PRO_STATE'
});

export const createAASubscription = (
  payload: AASubscriptionRequestPayload
): CreateAASubscriptionRequestAction => ({
  type: 'CREATE_AA_SUBSCRIPTION_REQUEST',
  payload
});

export const createAASubscriptionSuccess = (): CreateAASubscriptionSuccessAction => ({
  type: 'CREATE_AA_SUBSCRIPTION_SUCCESS'
});

export const createAASubscriptionFailure = (error: string): CreateAASubscriptionFailureAction => ({
  type: 'CREATE_AA_SUBSCRIPTION_FAILURE',
  payload: error
});

export const createOnlyAASubscription = (
  payload: AASubscriptionRequestPayload
): CreateOnlyAASubscriptionRequestAction => ({
  type: 'CREATE_ONLY_AA_SUBSCRIPTION_REQUEST',
  payload
});

export const postCreateOnlyAASubscriptionSuccess = (
  payload: PostAaChangeRequestSuccessPayload
): PostCreateOnlyAASubscriptionSuccessAction => ({
  type: 'CREATE_ONLY_AA_SUBSCRIPTION_SUCCESS',
  payload
});

export const executeAASubscription = (
  payload: ExecuteAaSubsCallParams
): ExecuteAASubscriptionRequestAction => ({
  type: 'EXECUTE_AA_SUBSCRIPTION_REQUEST',
  payload
});
